import beepFile from './beep.mp3';

const beep = new Audio(beepFile);

export const playBeep = () => {
  if (beep) {
    beep.play();
  }
};

export default playBeep;
